<div class="border rounded-large white-bg overflow-hidden">
  <div class="journey-price-container ps-medium-x ps-xsmall-y flex flex--middle">
    <div class="flex flex--center">
      <fcom-icon [attr.aria-label]="'Checkmark'" class="icon-medium" [name]="SvgLibraryIcon.CHECKMARK"></fcom-icon>
      <fcom-button
        data-testid="multi-city-journey-price-fare-family-info"
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
        [size]="ButtonSize.MEDIUM"
        [text]="
          'multiCity.flightSelection.fareFamilyForAll' | finLocalization: { fareFamilyName: fareFamily.brandName }
        "
        [icon]="{
          name: SvgLibraryIcon.INFO_BLOCK,
          position: IconPosition.RIGHT,
        }"
        (clickBtn)="openInfoModal()"
        class="ps-xxsmall-l"
      >
      </fcom-button>
    </div>
    <div class="change-ticket-type-container flex-1 align-right">
      <fcom-link
        data-testid="multi-city-journey-price-change-ticket-type"
        class="bold-type"
        (beforeNavigation)="openResetWarningModal()"
      >
        {{ 'multiCity.flightSelection.changeTicketType' | finLocalization }}
      </fcom-link>
    </div>
  </div>
  <div class="nordic-blue-25-bg ps-medium flex font-heading-5">
    <div data-testid="multi-city-journey-price-header" class="flex-2">
      {{ 'multiCity.flightSelection.totalPrice' | finLocalization }}
    </div>
    <div data-testid="multi-city-journey-price-total" class="flex-1 align-right">{{ price }}</div>
  </div>
</div>

<fcom-modal [(open)]="modalOpen" [title]="'modal.moreInfoTitle' | finLocalization">
  <fcom-notification
    subtitle
    [title]="'multiCity.flightSelection.fareFamilyNotification' | finLocalization"
    [layout]="NotificationLayout.EDGE_TO_EDGE"
  >
    {{ 'multiCity.flightSelection.ffModalNotificationSubtitle' | finLocalization }}
  </fcom-notification>
  <div class="pr-medium">
    <fin-fare-family-table [fareFamilies]="[fareFamily]"> </fin-fare-family-table>
    <article class="font-body-1 ps-medium">
      <section class="mr-xsmall-t">
        <div
          class="ticket-type-rules-info nordic-blue-900-text mr-medium-y ms-medium-x font-body-1"
          [innerHTML]="'bookingSearch.boundSelection.rulesMayVary' | finLocalization | finSafe: 'html'"
        ></div>
        <fin-expand
          [id]="'generalFareFamilyRulesAndRestrictions'"
          [key]="'generalFareFamilyRulesAndRestrictions'"
          [finElemTracker]="'benefits-more-information'"
          [finElemContext]="TRACKING_CONTEXT"
          [finElemType]="ElementTypes.ACCORDION"
          #expand
        >
          <div class="trigger flex flex--space-between nordic-blue-900-text">
            <h3 class="font-heading-3">
              {{ 'bookingSearch.boundSelection.informationAboutBenefits' | finLocalization }}
            </h3>
            <fcom-icon
              class="inline-block rotate icon-medium"
              [class.rotate-active]="expand.isOpen$ | async"
              [name]="SvgLibraryIcon.CHEVRON_DOWN"
            ></fcom-icon>
          </div>
          <div class="content pr-medium-y">
            <cms-unstyled-fragment
              class="benefits-information"
              [contentUrl$]="'fragments.benefitsInformation.url' | finLocalization | finToObservable"
            ></cms-unstyled-fragment>
          </div>
        </fin-expand>
      </section>
    </article>
  </div>
</fcom-modal>

<fcom-modal
  [(open)]="changeTicketTypeModalOpen"
  [title]="'modal.genericTitle' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [fitToContent]="true"
  data-testid="change-ticket-type-modal"
>
  <div class="pr-large font-body-1">
    {{ 'multiCity.flightSelection.changeTicketTypeWarningModal' | finLocalization }}
  </div>
  <div buttons>
    <fcom-button
      class="mr-xsmall-r"
      [text]="'actions.cancel' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      (clickBtn)="changeTicketTypeModalOpen = false"
    ></fcom-button>
    <fcom-button
      [text]="'multiCity.flightSelection.changeTicketType' | finLocalization"
      (clickBtn)="resetSelection.emit()"
      data-testid="change-ticket-type-button"
    ></fcom-button>
  </div>
</fcom-modal>
